import type { GalleryPlanFeatures } from './gallery.api';

// A paid setting's control is locked (disabled, with the "Pro" badge) while the Plan lacks it and
// the setting is at its free value; a value set before a downgrade stays shown and can be switched
// back (.scratch/gallery-look/spec.md, decisions 9 and 10). Features not loaded yet lock nothing:
// the API refuses anyway (GALLERY_PLAN_REQUIRED).
export function isPaidSettingLocked(
  features: Partial<GalleryPlanFeatures> | null | undefined,
  feature: keyof GalleryPlanFeatures,
  isFreeNow: boolean
): boolean {
  return features?.[feature] === false && isFreeNow;
}
